<script>
import { RadioGroup } from 'element-ui';

export default {
  extends: RadioGroup,
};
</script>

<style lang="scss">
  .el-radio-group--vertical {
    display: flex;
    flex-flow: column wrap;
    align-items: flex-start;
  }

  .el-radio-group--media {
    margin-left: rem(-12px);
    margin-right: rem(-12px);

    .el-radio.radio-media {
      max-width: rem(160px);
      flex-basis: rem(160px);
      padding-right: rem(15px);
      margin-bottom: rem(15px);
      padding-left: rem(15px);

      & + .el-radio {
        margin-left: 0;
      }
    }
  }

  .el-radio-group {
    &.is-disabled {
      cursor: not-allowed;
    }
  }
</style>
